import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Công nợ — iPad (ArPad.tsx). Dữ liệu mẫu và mã nghiệp vụ không dịch.
addMessages('vi', {
  'ad.title': 'Công nợ', 'ad.tabsAria': 'Xem công nợ theo',
  'ad.tCus': 'Theo khách', 'ad.tDeb': 'Debit / HĐ', 'ad.tAgt': 'Đại lý', 'ad.tMat': 'Chờ khớp tiền', 'ad.tRcp': 'Phiếu thu',
  'ad.pay': 'Ghi nhận thanh toán', 'ad.noWrite': 'Chưa mở ghi ở bản này', 'ad.listAria': 'Danh sách',
  'ad.findAria': 'Tìm', 'ad.findPh': 'Khách / số debit / JobID',
  'ad.rows': '{n} dòng', 'adp.rec': 'Phải thu', 'adp.over': 'quá hạn',
  'ad.emptyCusT': 'Không có khách phù hợp', 'ad.emptyCusD': 'Đổi từ khoá hoặc bỏ lọc.',
  'ad.quickView': 'Xem nhanh khách chưa mở ở bản này',
  'ad.emptyDebT': 'Không có debit / HĐ phù hợp', 'ad.emptyDebD': 'Đổi từ khoá.',
  'ad.agtT': 'Đại lý chưa mở ở bản này', 'ad.agtD': 'Số liệu đại lý chờ KTT chốt.',
});
addMessages('en', {
  'ad.title': 'Receivables', 'ad.tabsAria': 'View receivables by',
  'ad.tCus': 'By customer', 'ad.tDeb': 'Debit / invoice', 'ad.tAgt': 'Agents', 'ad.tMat': 'Awaiting match', 'ad.tRcp': 'Receipts',
  'ad.pay': 'Record payment', 'ad.noWrite': 'Writing is not enabled in this version', 'ad.listAria': 'List',
  'ad.findAria': 'Search', 'ad.findPh': 'Customer / debit no. / JobID',
  'ad.rows': '{n} rows', 'adp.rec': 'Receivable', 'adp.over': 'overdue',
  'ad.emptyCusT': 'No matching customers', 'ad.emptyCusD': 'Change the keyword or clear the filter.',
  'ad.quickView': 'Customer quick view is not enabled in this version',
  'ad.emptyDebT': 'No matching debits / invoices', 'ad.emptyDebD': 'Change the keyword.',
  'ad.agtT': 'Agents are not enabled in this version', 'ad.agtD': 'Agent figures are awaiting the chief accountant.',
});
